//import React from 'react';
//import './home.css';
import { useGetProductsQuery } from '@diditusa/shared/api/productsApi';
import React, { useEffect, useState } from 'react';
import './home.css'; // Make sure this CSS file is imported in your project
import { useNavigate, Link } from 'react-router-dom';
import SecurityProducts from '../../components/Product/SecurityProducts';
import LoadingIndicator from '@diditusa/shared/web_components/LoadingIndicator/loadingIndicator';
import { SecurityOption } from '@diditusa/shared/types/productTypes';
import { useLoadUserQuery } from '@diditusa/shared/api/sessionApi';
import SevenDayWeatherForecast from '../../components/WeatherForecast/SevenDayWeatherForecast';
import { useGetJobsQuery } from '@diditusa/shared/api/jobsApi';
import UserJobs from '../../components/Job/UserJobs';
import OrderFormStandalone from '../OrderForm/OrderFormStandalone';

const Home: React.FC = () => {
  const navigate = useNavigate();
  const { data: products, ...productsState } = useGetProductsQuery();
  const { data: user, ...loadUserState } = useLoadUserQuery();
  const { data: jobs, ...loadJobsState } = useGetJobsQuery();
  const [sortedProducts, setSortedProducts] = useState<SecurityOption[]>([]);
  const [sortedJobs, setSortedJobs] = useState<any[]>([]);

  useEffect(() => {
    if (!productsState.isLoading && products) {
      const sp = [...products];
      sp.sort((spa, spb) => spa.pricing.unitAmount - spb.pricing.unitAmount);
      setSortedProducts(sp);
    }
  }, [productsState.isLoading, products]);

  useEffect(() => {
    if (!loadJobsState.isLoading && jobs) {
      const now = new Date();

      // Filter for future jobs only
      const upcomingJobs = jobs.filter((job) => job.startTime.toJSDate() > now);

      // Find the single soonest upcoming job
      const soonestJob = upcomingJobs.reduce((soonest, current) => {
        return current.startTime.toJSDate() < soonest.startTime.toJSDate() ? current : soonest;
      }, upcomingJobs[0]);

      // Set the single job in an array if one exists
      setSortedJobs(soonestJob ? [soonestJob] : []);
    }
  }, [loadJobsState.isLoading, jobs]);

  const renderSecurityProducts = () => {
    if (productsState.isLoading || loadUserState.isLoading) {
      return <LoadingIndicator isVisible={productsState.isLoading || loadUserState.isLoading} />;
    }

    if (productsState.isError) {
      return <p>Error loading products</p>;
    }

    return <SecurityProducts products={sortedProducts} />;
  };

  const renderUpcomingJobs = () => {
    if (loadJobsState.isLoading) return <LoadingIndicator isVisible />;
    if (loadJobsState.isError) return <p>Error loading jobs</p>;

    if (sortedJobs.length === 0) {
      return (
        <div className='upcoming-card'>
          <div className='upcoming-image'></div>
          <img
            src='/NoExperiences.png'
            alt='No Protection'
            style={{ width: '600px', height: '150px', borderRadius: '20px' }}
            className='desktop-image'
          />
          <img
            src='/NoExperiencesMobile.png'
            alt='No Protection'
            style={{ width: '600px', height: '300px', borderRadius: '20px' }}
            className='mobile-image'
          />
          {/* <h2>No Upcoming Experiences</h2>
          <h3>You have no scheduled experiences</h3> */}
        </div>
      );
    }

    const getOnAgentNameClick = () => {
      return (jobId: number) => navigate(`/jobs/${jobId}`);
    };

    return (
      <div className='upcoming-protection-container'>
        {/* <p className='upcoming-protection'>Your Upcoming Experience</p> */}
        <UserJobs sortedJobs={sortedJobs} onAgentNameClick={getOnAgentNameClick()} />
      </div>
    );
  };

  return (
    <div className='home-wrapper'>
      <div className='home-layout'>
        <main className='home-main'>
          <div className='home-container'>
            <section className='welcome-section'>
              <div className='welcome-text'>
                <div className='welcome-customer-order'>
                  <div className='welcome-message'>
                    <h1>Welcome, {user?.firstName}</h1>
                    <h2>Your luxury experience begins here!</h2>
                    <OrderFormStandalone />

                    {/* <button
                      className='button-primary'
                      onClick={() => navigate('/new-order/1/Essential Protection')}
                    >
                      Get Protection
                    </button> */}
                  </div>
                  {/* <img src='/Cadi.jfif' style={{ width: '200px', height: '200px' }}></img> */}
                </div>
              </div>
              <div className='upcoming-section'>{renderUpcomingJobs()}</div>
            </section>

            {/* {renderSecurityProducts()} */}
            {/* <div className='weather-forecast'>
              <SevenDayWeatherForecast />
            </div> */}

            {/* <SevenDayWeatherForecast /> */}

            <footer className='home-footer'>
              <div className='footer-links'>
                <Link to='/contact'>Contact Us</Link>
                {/* <a href='#'>Support</a> */}
                <Link to='/refund'>Terms of Service</Link>
                <Link to='/privacy-policy'>Privacy Policy</Link>
              </div>
              <p>@2025 SAëF. All rights reserved.</p>
            </footer>
          </div>
        </main>
      </div>
    </div>
  );
};

export default Home;
